"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatSecToDate = exports.formatTime = void 0;
exports.formatTime = function (t) {
    if (t <= 0) {
        return "00";
    }
    return t > 9 ? "" + t : "0" + t;
};
exports.formatSecToDate = function (t) {
    var hour = exports.formatTime(Math.floor(t / 3600));
    var min = exports.formatTime(Math.floor((t / 60) % 60));
    var sec = exports.formatTime(Math.floor(t % 60));
    return "Ends in " + hour + ":" + min + ":" + sec;
};
